<template>
    <form role="form">
        <div class="modal-header">
            <h5 class="modal-title">Detail Pelanggan</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="height: 35vh; overflow-y: auto;">
            <div class="form-group">
                <label for="name" class="control-label">Nama Pelanggan</label>
                <input type="text" class="form-control" id="name" v-model="form.name" ref="name" required
                    pattern="([A-z\s]){2,}" placeholder="Masukkan Nama Pelanggan"/>
            </div>
            <div class="form-group">
                <label for="tel" class="control-label">No. Telepon</label>
                <input type="number" class="form-control" id="tel" ref="tel" required v-model="form.tel" onKeyPress="if(this.value.length==20) return false;"
                    placeholder="Masukkan Nomor Telepon" />
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onSubmit">Simpan</button>
        </div>
    </form>
</template>
<script>
    import "vue-select/dist/vue-select.css";

    export default {
        data() {
            return {
                form: {
                    name: null,
                    tel: null
                }
            }
        },
        emits: ['submit'],
        methods: {
            onSubmit(e) {
                this.$emit('submit', Object.assign({}, this.form));
            }
        }
    }
</script>